"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridUtils = exports.PriceNonComplianceType = exports.queryGridMoonStrategy = void 0;
const rxjs_1 = require("rxjs");
const react_1 = require("react");
const operators_1 = require("rxjs/operators");
const decimal_js_1 = __importDefault(require("decimal.js"));
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeErrorConstants_1 = require("./TradeErrorConstants");
const NumberTradeUtils_1 = require("./NumberTradeUtils");
const SimpleTrading_1 = require("../Trading/SimpleTrading");
const moonStrategy = {
    "BTC/USDT": {
        symbol: "BTC/USDT",
        base: "BTC",
        quote: "USDT",
        bottom: "6000",
        top: "60000",
        count: "500",
        grid_type: "arithmetic",
        use_mcoin_limit: "3000",
    },
    "ETH/USDT": {
        symbol: "ETH/USDT",
        base: "ETH",
        quote: "USDT",
        bottom: "1000",
        top: "10000",
        count: "500",
        grid_type: "arithmetic",
    },
    "ETH/BTC": {
        symbol: "ETH/BTC",
        base: "ETH",
        quote: "BTC",
        bottom: "0.04",
        top: "0.35",
        count: "500",
        grid_type: "arithmetic",
    },
};
/**
 * 获取天地单策略配置
 * @param symbol
 */
const queryMoonStrategyData = () => {
    const configHost = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().CONFIG_HOST;
    return trade_utils_lib_1.ObservableUtils.get(`${configHost}/pionex_strategy_param.json`, null, { "Cache-Control": "max-age=0" });
};
const queryGridMoonStrategy = (symbol) => {
    return queryMoonStrategyData().pipe((0, operators_1.map)((data) => {
        var _a;
        const item = (_a = data === null || data === void 0 ? void 0 : data.moon) === null || _a === void 0 ? void 0 : _a[symbol];
        if (item) {
            return item;
        }
        throw "not find data: " + JSON.stringify(data);
    }));
};
exports.queryGridMoonStrategy = queryGridMoonStrategy;
var PriceNonComplianceType;
(function (PriceNonComplianceType) {
    PriceNonComplianceType[PriceNonComplianceType["topNonCompliance"] = 0] = "topNonCompliance";
    PriceNonComplianceType[PriceNonComplianceType["bottomNonCompliance"] = 1] = "bottomNonCompliance";
    PriceNonComplianceType[PriceNonComplianceType["rangeNonCompliance"] = 2] = "rangeNonCompliance";
})(PriceNonComplianceType = exports.PriceNonComplianceType || (exports.PriceNonComplianceType = {}));
exports.GridUtils = {
    checkGridBalance(symbol, baseAvailable, quoteAvailable, high, low, perVolume, gridCount, tradeApi, market) {
        const precision = {
            amount: symbol.amount,
            price: symbol.precision,
        };
        const limit = symbol.limit;
        const body = {
            got_base_amount: `${baseAvailable}`,
            got_quote_amount: `${quoteAvailable}`,
            market: market,
            base: symbol.base,
            quote: symbol.quote,
            top: `${high}`,
            bottom: `${low}`,
            per_volume: `${perVolume}`,
            row_cnt: `${gridCount}`,
            precision: precision,
            limits: limit,
        };
        return (0, trade_utils_lib_1.requestWithRetry)(() => tradeApi.checkGridRequireBalance(body), {
            maxRetryCount: 3,
        });
    },
    processCheckGridBalanceResult(result, symbol, baseBalance, quoteBalance, tradeApi, $st, price) {
        let errorMsg = "";
        let needBalance = false;
        let balanceMsg = "";
        if (!result.enough) {
            errorMsg = result.errMsg
                ? exports.GridUtils.transRequireBalanceErrMsg(result.errMsg, symbol.baseDisplay, symbol.quote, $st)
                : TradeErrorConstants_1.TradeErrorConstants.gridUnknownError($st);
            return {
                canCreate: false,
                error: errorMsg,
                needBalance: false,
                balanceMsg: "",
            };
        }
        else {
            const myBaseBalance = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(baseBalance, symbol.amount).toNumber();
            const myQuoteBalance = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(quoteBalance, symbol.precision).toNumber();
            const needBaseBalance = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(result.needBase, symbol.amount, decimal_js_1.default.ROUND_CEIL).toNumber();
            const needQuoteBalance = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(result.needQuote, symbol.precision, decimal_js_1.default.ROUND_CEIL).toNumber();
            if (myBaseBalance < needBaseBalance) {
                const baseOffset = NumberTradeUtils_1.NumberTradeUtils.toAmountBySymbol(tradeApi, needBaseBalance - myBaseBalance, symbol, decimal_js_1.default.ROUND_CEIL);
                const msg = TradeErrorConstants_1.TradeErrorConstants.gridBalanceOrderBuyTip(baseOffset + ` ${symbol.baseDisplay}`, $st);
                needBalance = true;
                balanceMsg = msg;
            }
            else if (myQuoteBalance < needQuoteBalance) {
                const quoteOffset = needQuoteBalance - myQuoteBalance;
                let needToSellBase = "--";
                if (price) {
                    needToSellBase = NumberTradeUtils_1.NumberTradeUtils.toAmountBySymbol(tradeApi, quoteOffset / price, symbol, decimal_js_1.default.ROUND_UP);
                }
                const msg = TradeErrorConstants_1.TradeErrorConstants.gridBalanceOrderSellTip(needToSellBase + ` ${symbol.baseDisplay}`, $st);
                needBalance = true;
                balanceMsg = msg;
            }
        }
        const checkBalanceResult = {
            canCreate: result.enough,
            error: errorMsg,
            needBalance: needBalance,
            balanceMsg: balanceMsg,
        };
        return checkBalanceResult;
    },
    requireGridPerVolume(tradeApi, high, low, gridCount, symbol, balancePercent, baseBalance, quoteBalance, market, $st) {
        return (0, rxjs_1.of)(0)
            .pipe((0, operators_1.map)(() => {
            if (balancePercent > 0.95) {
                throw TradeErrorConstants_1.TradeErrorConstants.girdAmountPercentRatherThan95($st);
            }
            if (!high || !low) {
                return TradeErrorConstants_1.TradeErrorConstants.inputPriceRange($st);
            }
            if (!gridCount) {
                return TradeErrorConstants_1.TradeErrorConstants.inputGridCount($st);
            }
            if (low >= high) {
                throw TradeErrorConstants_1.TradeErrorConstants.gridLowNeedLowerThanHigh($st);
            }
            if (gridCount < 2 || gridCount > 99) {
                return TradeErrorConstants_1.TradeErrorConstants.gridCount99RangeError($st);
            }
            if (!baseBalance && !quoteBalance) {
                return TradeErrorConstants_1.TradeErrorConstants.balanceNotEnough($st);
            }
            const request = {
                balance_percent: `${balancePercent}`,
                got_base_amount: `${baseBalance}`,
                got_quote_amount: `${quoteBalance}`,
                market: market,
                base: symbol.base,
                quote: symbol.quote,
                top: high,
                bottom: low,
                per_volume: 0,
                row_cnt: gridCount,
                precision: symbol.precision !== undefined ? symbol.precision : 4,
                limits: symbol.limit,
            };
            return request;
        }))
            .pipe((0, operators_1.flatMap)((params) => {
            return (0, trade_utils_lib_1.requestWithRetry)(() => tradeApi.requireGridPervolume(params), {
                maxRetryCount: 3,
            });
        }));
    },
    getProfitPerGrid(high, low, count, feeRate) {
        if (!high || !low || !count || low >= high || count < 2) {
            return undefined;
        }
        const priceStep = (high - low) / (count - 1);
        let priceBelow = 0;
        let minProfit = 0;
        let maxProfit = 0;
        for (let price = low; price <= high; price += priceStep) {
            if (priceBelow !== 0) {
                if (maxProfit === 0) {
                    maxProfit = (price * (1 - feeRate) - priceBelow * (1 + feeRate)) / priceBelow;
                }
                minProfit = (price * (1 - feeRate) - priceBelow * (1 + feeRate)) / priceBelow;
            }
            priceBelow = price;
        }
        return [minProfit, maxProfit];
    },
    useTotalBalance(baseBalance, quoteBalance, price) {
        return (0, react_1.useMemo)(() => {
            return new trade_utils_lib_1.SafeDecimal(baseBalance).mul(new trade_utils_lib_1.SafeDecimal(price)).add(new trade_utils_lib_1.SafeDecimal(quoteBalance)).toNumber();
        }, [baseBalance, quoteBalance, price]);
    },
    useBalanceDisplay(tradeApi, baseBalance, quoteBalance, total, symbol) {
        return (0, react_1.useMemo)(() => {
            const totalStr = `= ${NumberTradeUtils_1.NumberTradeUtils.toPriceBySymbol(tradeApi, total, symbol)} ${symbol.quote}`;
            const descStr = `(${NumberTradeUtils_1.NumberTradeUtils.toAmountBySymbol(tradeApi, baseBalance, symbol)}${symbol.baseDisplay}+` +
                `${NumberTradeUtils_1.NumberTradeUtils.toPriceBySymbol(tradeApi, quoteBalance, symbol)}${symbol.quote})`;
            return [totalStr, descStr];
        }, [baseBalance, quoteBalance, total, symbol]);
    },
    useGridAIStrategy(tradeApi, base, quote, market) {
        const [item, setItem] = (0, react_1.useState)(undefined);
        const [loading, setLoading] = (0, react_1.useState)(true);
        const [error, setError] = (0, react_1.useState)("");
        (0, react_1.useEffect)(() => {
            setLoading(true);
            const retryOb = (0, trade_utils_lib_1.requestWithRetry)(() => tradeApi.requireAIStrategyWithSymbol(market, base, quote), {
                maxRetryCount: 3,
            }).subscribe((data) => {
                const aiItem = data;
                setItem(aiItem);
                setError("");
                setLoading(false);
            }, (error) => {
                setError(JSON.stringify(error) || `${error}`);
                setLoading(false);
            });
            return () => retryOb && retryOb.unsubscribe();
        }, [base, quote]);
        return [item, loading, error];
    },
    /**
     * 获取天地单策略配置
     * @param symbol
     */
    useMoonStrategy(symbol) {
        const [moonStrategyItem, setMoonStrategyItem] = (0, react_1.useState)();
        (0, react_1.useEffect)(() => {
            setMoonStrategyItem(undefined);
            const LocalStorageKey = "pionex_strategy_param_" + symbol;
            const promise = (0, trade_utils_lib_1.getTradeDependencyInstance)().getLocalStorage().getItem(LocalStorageKey);
            const subscription = (0, rxjs_1.from)(promise)
                .pipe((0, operators_1.map)((data) => {
                if (!data) {
                    return null;
                }
                try {
                    return JSON.parse(data);
                }
                catch (e) {
                    return null;
                }
            }))
                .pipe((0, operators_1.flatMap)((data) => {
                var _a;
                let item = (_a = data === null || data === void 0 ? void 0 : data.moon) === null || _a === void 0 ? void 0 : _a[symbol];
                if (!item) {
                    item = moonStrategy[symbol];
                }
                if (item) {
                    setMoonStrategyItem(item);
                }
                return queryMoonStrategyData();
            }))
                .subscribe((data) => {
                var _a;
                (0, trade_utils_lib_1.getTradeDependencyInstance)().getLocalStorage().setItem(LocalStorageKey, JSON.stringify(data));
                const item = (_a = data === null || data === void 0 ? void 0 : data.moon) === null || _a === void 0 ? void 0 : _a[symbol];
                if (item) {
                    setMoonStrategyItem(item);
                }
            }, (error) => { });
            return () => subscription.unsubscribe();
        }, [symbol]);
        return moonStrategyItem;
    },
    useMinTotalBalance(aiItem, symbol, ticker, baseBalance, quoteBalance, tradeApi, market) {
        const [minTotal, setMinTotal] = (0, react_1.useState)(0);
        (0, react_1.useEffect)(() => {
            if (!aiItem) {
                setMinTotal(0);
                return;
            }
            const minPerVolume = SimpleTrading_1.SimpleTrading.getMinAmount(symbol, aiItem.low) || 0;
            const subscribe = this.checkGridBalance(symbol, baseBalance, quoteBalance, aiItem.high, aiItem.low, minPerVolume, aiItem.grid_count, tradeApi, market).subscribe((_data) => {
                const data = _data;
                const realNeedBase = trade_utils_lib_1.NumberCommonUtils.str2number(data.realNeedBase);
                const realNeedQuote = trade_utils_lib_1.NumberCommonUtils.str2number(data.realNeedQuote);
                const minTotal = realNeedBase * ticker.latest + realNeedQuote;
                setMinTotal(minTotal);
            }, (error) => {
                setMinTotal(0);
            });
            return () => {
                subscribe.unsubscribe();
            };
        }, [aiItem, symbol, baseBalance, quoteBalance]);
        return minTotal;
    },
    checkBalanceEnoughRequest(high, low, perVolume, gridCount, baseBalance, quoteBalance, $st, stop, minPerVolume, currentPrice) {
        if (!high || !low) {
            return TradeErrorConstants_1.TradeErrorConstants.inputPriceRange($st);
        }
        if (!gridCount) {
            return TradeErrorConstants_1.TradeErrorConstants.inputGridCount($st);
        }
        if (gridCount < 2 || gridCount > 99) {
            return TradeErrorConstants_1.TradeErrorConstants.gridCount99RangeError($st);
        }
        if (!perVolume) {
            return TradeErrorConstants_1.TradeErrorConstants.inputGridPerVolume($st);
        }
        if (!baseBalance && !quoteBalance) {
            return TradeErrorConstants_1.TradeErrorConstants.balanceNotEnough($st);
        }
        if (low >= high) {
            return TradeErrorConstants_1.TradeErrorConstants.gridCheckPriceRange($st);
        }
        if (stop && stop >= low) {
            return TradeErrorConstants_1.TradeErrorConstants.gridCheckPriceRange($st);
        }
        if (stop && currentPrice && stop >= currentPrice) {
            return TradeErrorConstants_1.TradeErrorConstants.stopCannotHighThanCurrentPrice($st);
        }
        if (minPerVolume && perVolume < minPerVolume) {
            return TradeErrorConstants_1.TradeErrorConstants.lowAmount(minPerVolume, $st);
        }
        return undefined;
    },
    transRequireBalanceErrMsg(errMsg, base, quote, $st) {
        if (errMsg === "error_row_is_not_illegal") {
            return TradeErrorConstants_1.TradeErrorConstants.gridCount99RangeError($st);
        }
        else if (errMsg === "error_per_volume_hit_amount_min") {
            return TradeErrorConstants_1.TradeErrorConstants.gridPerVolumeHitAmountMin($st);
        }
        else if (errMsg === "error_interval_price_too_small") {
            return TradeErrorConstants_1.TradeErrorConstants.gridPriceTooSmall($st);
        }
        else if (errMsg === "error_grid_price_hit_price_min") {
            return TradeErrorConstants_1.TradeErrorConstants.gridPriceRangeTooLarge($st);
        }
        else if (errMsg === "error_grid_cost_hit_cost_min") {
            return TradeErrorConstants_1.TradeErrorConstants.gridCostHitCostMin($st);
        }
        else if (errMsg === "error_init_grids_error") {
            return TradeErrorConstants_1.TradeErrorConstants.gridUnknownError($st);
        }
        else if (errMsg === "error_duplicate_grid") {
            return TradeErrorConstants_1.TradeErrorConstants.gridDuplicateGrid($st);
        }
        else if (errMsg === "error_price_is_too_broad") {
            return TradeErrorConstants_1.TradeErrorConstants.gridPriceRangeTooLarge($st);
        }
        else if (errMsg === "error_exchange_busy") {
            return TradeErrorConstants_1.TradeErrorConstants.gridExchangeBusy($st);
        }
        else if (errMsg === "error_sign_failed") {
            return TradeErrorConstants_1.TradeErrorConstants.gridSignFailed($st);
        }
        else if (errMsg === "error_price_is_too_high") {
            return TradeErrorConstants_1.TradeErrorConstants.gridPriceTooHigh($st);
        }
        else if (errMsg === "error_price_is_too_low") {
            return TradeErrorConstants_1.TradeErrorConstants.gridPriceTooSmall($st);
        }
        else if (errMsg === "error_balance_not_enough_both_side") {
            return TradeErrorConstants_1.TradeErrorConstants.balanceNotEnough($st);
        }
        else if (errMsg === "error_balance_not_enough_quote") {
            return TradeErrorConstants_1.TradeErrorConstants.quoteNotEnough(quote, $st);
        }
        else if (errMsg === "error_balance_not_enough_base") {
            return TradeErrorConstants_1.TradeErrorConstants.baseNotEnough(base, $st);
        }
        else if (errMsg === "error_in_get_balance") {
            return $st("grid_err_error_in_get_balance");
        }
        else if (errMsg === "error_in_place_grid_balance_order") {
            return $st("grid_err_error_balance_not_enough_both_side");
        }
        else if (errMsg === "error_in_wait_sell_grid_balance") {
            return $st("grid_err_error_in_wait_sell_grid_balance");
        }
        else if (errMsg === "error_in_grid_stop_loss") {
            return $st("grid_err_error_in_grid_stop_loss");
        }
        else if (errMsg === "error_in_cancel_orders") {
            return $st("grid_err_error_in_cancel_orders");
        }
        else if (errMsg === "error_in_place_grid_orders") {
            return $st("grid_err_error_in_place_grid_orders");
        }
        else if (errMsg === "error_in_wait_order_done") {
            return $st("grid_err_error_in_wait_order_done");
        }
        else if (errMsg === "error_none_balances_got") {
            return $st("grid_err_error_in_get_balance");
        }
        else if (errMsg === "error_got_none_check_grids") {
            return $st("grid_err_error_in_wait_order_done");
        }
        else if (errMsg === "error_not_found_cross_order") {
            return $st("grid_err_error_in_wait_order_done");
        }
        else if (errMsg === "error_got_none_cb_info") {
            return $st("grid_err_error_in_wait_order_done");
        }
        else if (errMsg === "error_got_unknown_cb_action") {
            return $st("grid_err_error_got_unknown_cb_action");
        }
        else if (errMsg === "error_add_not_balanced_monitor_error") {
            return $st("grid_err_error_add_not_balanced_monitor_error");
        }
        else if (errMsg === "error_add_balanced_monitor_error") {
            return $st("grid_err_error_add_balanced_monitor_error");
        }
        else if (errMsg === "error_stop_in_loss") {
            return $st("grid_err_error_stop_in_loss");
        }
        else if (errMsg === "error_balance_not_enough_in_run_time") {
            return $st("grid_err_error_balance_not_enough_in_run_time");
        }
        else if (errMsg === "error_got_unknown_order_id") {
            return $st("grid_err_error_got_unknown_order_id");
        }
        return errMsg;
    },
    useRequiredBalance(symbol, baseAvailable, quoteAvailable, high, low, perVolume, gridCount, price, tradeApi, market, $st) {
        const [requiredBalance, setRequiredBalance] = (0, react_1.useState)("-");
        const [requiredBalanceDesc, setRequiredBalanceDesc] = (0, react_1.useState)("-");
        const [loading, setLoading] = (0, react_1.useState)(false);
        const [error, setError] = (0, react_1.useState)("");
        (0, react_1.useEffect)(() => {
            const highNum = NumberTradeUtils_1.NumberTradeUtils.toPriceNumBySymbol(tradeApi, high, symbol);
            const lowNum = NumberTradeUtils_1.NumberTradeUtils.toPriceNumBySymbol(tradeApi, low, symbol);
            const perVNum = NumberTradeUtils_1.NumberTradeUtils.toAmountNumBySymbol(tradeApi, perVolume, symbol);
            const gridCountNum = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(gridCount, 0).toNumber();
            const localErr = this.checkBalanceEnoughRequest(highNum, lowNum, perVNum, gridCountNum, baseAvailable, quoteAvailable, $st);
            if (localErr) {
                setRequiredBalance("--");
                setRequiredBalanceDesc("");
                setLoading(false);
                setError("");
                return;
            }
            setLoading(true);
            const sub = this.checkGridBalance(symbol, baseAvailable, quoteAvailable, highNum, lowNum, perVNum, gridCountNum, tradeApi, market).subscribe((data) => {
                if (data.needBase !== "None" ||
                    data.needQuote !== "None" ||
                    data.realNeedBase !== "None" ||
                    data.realNeedQuote !== "None") {
                    const realNeedBase = trade_utils_lib_1.NumberCommonUtils.str2number(data.realNeedBase);
                    const realNeedQuote = trade_utils_lib_1.NumberCommonUtils.str2number(data.realNeedQuote);
                    const totalPrice = NumberTradeUtils_1.NumberTradeUtils.toPriceBySymbol(tradeApi, realNeedBase * price + realNeedQuote, symbol, decimal_js_1.default.ROUND_UP);
                    const totalPriceStr = `= ${totalPrice} ${symbol.quote.toUpperCase()}`;
                    const needBase = NumberTradeUtils_1.NumberTradeUtils.toAmountBySymbol(tradeApi, data.needBase, symbol, decimal_js_1.default.ROUND_UP);
                    const needQuote = NumberTradeUtils_1.NumberTradeUtils.toPriceBySymbol(tradeApi, data.needQuote, symbol, decimal_js_1.default.ROUND_UP);
                    const descStr = `(${needBase}${symbol.baseDisplay.toUpperCase()}+${needQuote}${symbol.quote.toUpperCase()})`;
                    setRequiredBalance(totalPriceStr);
                    setRequiredBalanceDesc(descStr);
                    setError("");
                }
                else {
                    setRequiredBalance("--");
                    setRequiredBalanceDesc("--");
                    setError(this.transRequireBalanceErrMsg(data.errMsg, symbol.baseDisplay, symbol.quote, $st));
                }
                setLoading(false);
            }, (error) => {
                setLoading(false);
                setRequiredBalance("--");
                setRequiredBalanceDesc("--");
                setError(JSON.stringify(error) || `${error}`);
            });
            return () => {
                if (sub) {
                    sub.unsubscribe();
                }
            };
        }, [symbol, baseAvailable, quoteAvailable, high, low, perVolume, gridCount, tradeApi, market, $st]);
        return [requiredBalance, requiredBalanceDesc, loading, error];
    },
    /**
     *
     * @param top
     * @param underlayPrice 标的价格， 有触发价则为触发价，没有则为当前价
     * @param bottom
     * @param $st
     */
    priceRangeComplianceCheck($st, underlayPrice, top, bottom) {
        let tempResult = true;
        let tempReason = undefined;
        if (top.lessThan(underlayPrice.div(10))) {
            tempResult = false;
            tempReason = {
                reason: $st("price_range_check_top_recommend"),
                type: PriceNonComplianceType.topNonCompliance,
            };
        }
        if (bottom.greaterThan(underlayPrice.mul(10))) {
            tempResult = false;
            tempReason = {
                reason: $st("price_range_check_bottom_recommend"),
                type: PriceNonComplianceType.bottomNonCompliance,
            };
        }
        if (!bottom.equals(0) && top.greaterThan(bottom.mul(100))) {
            tempResult = false;
            tempReason = {
                reason: $st("price_range_check_range_recommend"),
                type: PriceNonComplianceType.rangeNonCompliance,
            };
        }
        return {
            result: tempResult,
            info: tempReason,
        };
    },
};
